import type { QuickbooksMapping } from '@contracts/client/QuickbooksMapping';
import type { Client } from '@src/clients/domain/Client';
import { ClientsClient } from '@src/clients/services/ClientsClient';
import { useMutation } from '@tanstack/react-query';

interface Props {
  clientId: string;
  onSuccess: (client: Client) => void;
  onError: () => void;
}

export const useUpdateQuickbooksMapping = ({
  clientId,
  onSuccess,
  onError,
}: Props) => {
  const { mutate, isPending } = useMutation({
    mutationFn: (mapping: QuickbooksMapping) => {
      return ClientsClient.updateQuickbooksMapping({ clientId, mapping });
    },
    onSuccess,
    onError,
  });

  return {
    updateQuickbooksMapping: mutate,
    loading: isPending,
  };
};
